import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { BaseUserService } from "@smarterplan/ngx-smarterplan-core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ManagerGuard implements CanActivate {
    constructor(private userService: BaseUserService, private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (
            this.userService.hasManagerRoleInAnyMission() ||
            this.userService.isGuide()
        ) {
            return true;
        }
        return this.router.parseUrl("/notauthorized");
    }
}
